export default "__VITE_ASSET__cf9e8530__"